<template>
  <div class="do-filters text-dark">
    <div class="do-filters__selected">
      <div class="do-filters__dropdown__container" v-on-clickaway="onClickOutside">
        <button class="do-bttn do-bttn__filter" @click="isShowDropdown = !isShowDropdown">
          <span class="icon-filter"></span>
          {{ i18n['substitutes'] }}
          <div class="do-filters__divider"></div>
          <span class="do-filters__selected-filters" v-if="allSelectedFiltersLength === 0">
            {{ i18n['select_filters'] }}
          </span>
          <template v-else>
            <span class="do-badge">
              {{ allSelectedFiltersLength }} {{ i18n['selected'] }}
            </span>
          </template>
        </button>
        <transition name="d-dropdown">
          <div class="do-filters__dropdown" v-if="isShowDropdown">
            <button @click="$emit('clearAll')" class="do-filters__button-transparent">{{ i18n['clear_all'] }}</button>
            <div class="do-filters__dropdown__item">
              <h5>{{ i18n['filter_by_criteria'] }}</h5>
              <button class="do-bttn__quick-filter"
                      :class="{'do-bttn__quick-filter--selected': getIsQuickFilterSelected(quickFilter)}"
                      v-for="quickFilter in quickFilters"
                      @click="$emit('toggleQuickFilter', quickFilter)"
                      :key="quickFilter.value">
                <span class="icon-checkmark-circle"></span>
                {{ i18n[quickFilter.titleKey] }}
              </button>
            </div>
            <div class="do-filters__dropdown__item">
              <h5>{{ i18n['filter_by_group'] }}</h5>
              <DoFiltersFilter
                :title="i18n['groups']"
                :tags="tags"
                :selectedTags="selectedTags"
                @select="$emit('select', $event)"
                @clear="$emit('clear')">
              </DoFiltersFilter>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
const I18N = {
  da: {
    substitutes: 'Vikarer',
    select_filters: 'Vælg filtre',
    selected: 'valgt',
    clear_all: 'Ryd alle',
    filter_by_criteria: 'Vis alle der opfylder ét eller flere af følgende kriterier',
    filter_by_group: 'Eller er med i en eller flere af disse grupper',
    groups: 'Grupper',
    sub_events_available: 'Har rådighedstimer',
    sub_events_two_in_some_class: 'Er to eller flere samtidig i en klasse',
    sub_events_canceled: 'Har aflyste timer'
  },
  en: {
    substitutes: 'Substitutes',
    select_filters: 'Select filters',
    selected: 'selected',
    clear_all: 'Clear all',
    filter_by_criteria: 'Show all that meet one or more of the following criteria',
    filter_by_group: 'Or belong to one or more of these groups',
    groups: 'Groups',
    sub_events_available: 'Has available hours',
    sub_events_two_in_some_class: 'Two or more are in a class at the same time',
    sub_events_canceled: 'Has canceled hours'
  },
  nb: {
    substitutes: 'Vikarer',
    select_filters: 'Velg filtre',
    selected: 'valgt',
    clear_all: 'Fjern alle',
    filter_by_criteria: 'Vis alle som oppfyller ett eller flere av følgende kriterier',
    filter_by_group: 'Eller er med i en eller flere av disse gruppene',
    groups: 'Grupper',
    sub_events_available: 'Har tilgjengelige timer',
    sub_events_two_in_some_class: 'To eller flere er samtidig i en klasse',
    sub_events_canceled: 'Har avlyste timer'
  }
}

import DDropdown from '../common/DDropdown.vue'
import DoFiltersFilter from './DoFiltersFilter.vue'
import {mixin as clickaway} from 'vue-clickaway'
export default {
  mixins: [clickaway],
  components: {DoFiltersFilter, DDropdown},
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    selectedTags: {
      type: Array,
      default: () => [] // ['Vikarer', 'Team 1', etc]
    },
    selectedQuickFilters: {
      type: Array,
      default: () => []
    },
    theSelectedSorting: {
      type: String,
      default: 'name'
    }
  },
  data () {
    return {
      isShowDropdown: false,
      quickFilters: [
        {value: 'sub_events_canceled', titleKey: 'sub_events_canceled'},
        {value: 'sub_events_available', titleKey: 'sub_events_available'},
        {value: 'sub_events_two_in_some_class', titleKey: 'sub_events_two_in_some_class'}
      ]
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N['en']
    },
    allSelectedFiltersLength () {
      const quickFilters = Object.keys(this.selectedQuickFilters)
      return quickFilters.length + this.selectedTags.length
    }
  },
  methods: {
    getIsQuickFilterSelected (quickFilter) {
      return this.selectedQuickFilters.find(selectedQuickFilter => selectedQuickFilter === quickFilter.value)
    },
    onClickOutside () {
      this.isShowDropdown = false
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.do-bttn.do-bttn__filter {
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  gap: 0.75rem;
  border: 1px dashed #e4e4e7;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, .05);
}

.do-bttn.do-bttn__filter:hover {
  background-color: #f4f4f5;
}

.do-bttn.do-bttn__filter > .icon-filter {
  font-size: 0.85rem;
}

.do-filters__divider {
  background: #e4e4e7;
  height: 65%;
  min-height: 2px;
  width: 1px;
}

.do-badge {
  background: #f4f4f5;
  border-radius: 4px;
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  padding: .15rem .35rem;
}

.do-filters__dropdown {
  width: 650px;
}

.do-bttn__quick-filter {
  display: inline-flex;
  align-items: center;
  background: transparent;
  color: #6c7a87;
  border: 1px solid #e4e4e7;
  opacity: 0.8;
  margin-right: 1rem;
}

.do-bttn__quick-filter > span {
  opacity: 0;
  width: 0;
}

.do-bttn__quick-filter.do-bttn__quick-filter--selected {
  background-color: aliceblue;
  opacity: 1;
  color: var(--primary);
  border-color: var(--primary);
}

.do-bttn__quick-filter.do-bttn__quick-filter--selected > span {
  opacity: 1;
  width: auto;
  margin-right: 0.75rem;
}

.do-filters__dropdown__item {
  margin-bottom: 1rem;
}

.sort-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.sort-item:not(.sort-item--selected) > span {
  opacity: 0;
}

.sort-item.sort-item--selected {
  color: var(--primary);
}

.do-filters__dropdown__item .d-dropdown-container {
  display: inline-block;
}

.do-filters__dropdown__container {
  position: relative;
}

.do-filters__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 2rem);
  right: 0;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0.5rem;
  min-width: 100px;
  margin-top: -10px !important;
}
</style>



// WEBPACK FOOTER //
// DoFilters.vue?55b328e9